export default __webpack_public_path__ + "static/media/solutions-mob.cd39e67c.svg";